import React from 'react';
import type { FC } from 'react';
import { BasketIcon, BrandLogo } from '../icons';

export const ErrorSaveHeader: FC = () => (
    <header>
        <nav className="flex w-full items-center justify-between bg-white px-4 py-6 shadow-md shadow-black/5 dark:shadow-black/10 sm:px-8 lg:px-16">
            <a href="/" data-testid="brand-logo-basket-url" aria-label="brand logo link to cart">
                <BrandLogo />
            </a>

            <div className="ml-auto flex items-center">
                <a
                    href="/shopping-cart"
                    data-testid="header-basket-url"
                    aria-label="link to basket"
                >
                    <div className="flex items-center space-x-2">
                        <BasketIcon />
                    </div>
                </a>
            </div>
        </nav>
    </header>
);
